"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconInfoOutline = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M11 9 13 9 13 7 11 7M12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20M12 2C6.4772 2 2 6.4772 2 12C2 14.6522 3.0536 17.1957 4.9289 19.0711C6.8043 20.9464 9.3478 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.3478 20.9464 6.8043 19.0711 4.9289C17.1957 3.0536 14.6522 2 12 2M11 17 13 17 13 11 11 11 11 17Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconInfoOutline')(IconInfoOutline);